import * as React from "react";
import { forwardRef } from "react";
const SvgPasswordIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 16, viewBox: "0 0 12 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6 0C3.8 0 2 1.8 2 4V5.5C0.8 6.6 0 8.2 0 10C0 13.3 2.7 16 6 16C9.3 16 12 13.3 12 10C12 8.2 11.2 6.6 10 5.5V4C10 1.8 8.2 0 6 0ZM7 10.7V13H5V10.7C4.4 10.4 4 9.7 4 9C4 7.9 4.9 7 6 7C7.1 7 8 7.9 8 9C8 9.7 7.6 10.4 7 10.7ZM8 4.4C7.4 4.1 6.7 4 6 4C5.3 4 4.6 4.1 4 4.4V4C4 2.9 4.9 2 6 2C7.1 2 8 2.9 8 4V4.4Z", fill: "#999999" }));
const ForwardRef = forwardRef(SvgPasswordIcon);
export { ForwardRef as ReactComponent };
